import type { ReactNode } from 'react';
import type { RuntimeSnapshot } from '@/runtime/useRuntimeDiagnostics';

interface RuntimeDebugOverlayProps {
  debugEnabled: boolean;
  pathname: string;
  snapshot: RuntimeSnapshot;
}

function Field({ children }: { children: ReactNode }) {
  return <div>{children}</div>;
}

export function RuntimeDebugOverlay({ debugEnabled, pathname, snapshot }: RuntimeDebugOverlayProps) {
  if (!debugEnabled) return null;

  return (
    <aside className="pointer-events-none fixed right-2 top-2 z-[999] max-w-[min(86vw,360px)] rounded-2xl bg-[rgba(18,18,18,0.88)] px-3 py-2 text-[10px] leading-[1.35] text-white shadow-[0_20px_40px_rgba(0,0,0,0.35)] backdrop-blur-md">
      <div className="font-semibold text-[rgba(255,255,255,0.92)]">
        runtime {snapshot.buildSha}
      </div>
      <div className="text-[rgba(255,255,255,0.6)]">{snapshot.builtAt}</div>
      <div className="text-[rgba(255,255,255,0.72)]">{pathname}</div>
      <Field>
        inner {snapshot.innerWidth}×{snapshot.innerHeight}
      </Field>
      <Field>
        client {snapshot.clientWidth}×{snapshot.clientHeight}
      </Field>
      <Field>
        vv {snapshot.visualViewportWidth ?? 'n/a'}×{snapshot.visualViewportHeight ?? 'n/a'} s=
        {snapshot.visualViewportScale ?? 'n/a'}
      </Field>
      <Field>
        tg {snapshot.tgViewportHeight ?? 'n/a'} / {snapshot.tgStableHeight ?? 'n/a'} / {snapshot.tgPlatform ?? 'n/a'}
      </Field>
      <Field>
        safe {snapshot.safeAreaTop} {snapshot.safeAreaRight} {snapshot.safeAreaBottom} {snapshot.safeAreaLeft}
      </Field>
      <Field>
        root {snapshot.rootFontSize}px / dpr {snapshot.devicePixelRatio} / {snapshot.breakpointMode}
      </Field>
    </aside>
  );
}
